import { EntityService } from '../EntityService';

export type AdjustmentReasonOption = {
  value: string;
  label: string;
  code: string;
  name: string;
};

export class OneBtsCatalogService extends EntityService {
  static entity = 'app/invoice/01-bts-location-options';

  /** Lấy danh sách mã tỉnh cho các trường địa điểm trên hóa đơn. */
  static getOneBtsCities(keyword?: string) {
    return this.axios
      .get(`${this.entity}/provinces`, { params: { keyword } })
      .then(res => res.data);
  }

  /** Lấy danh sách mã xã/phường theo mã tỉnh đã chọn. */
  static getOneBtsWards(provinceCode: string, keyword?: string) {
    return this.axios
      .get(`${this.entity}/wards`, { params: { provinceCode, keyword } })
      .then(res => res.data);
  }

  /** Lấy danh mục lý do xử lý sai sót theo loại nghiệp vụ và từ khóa tìm kiếm. */
  static getAdjustmentReasonCatalog(type?: number, keyword?: string) {
    return this.axios
      .get('app/adjustment-reason-catalog', { params: { type, keyword } })
      .then(res => {
        const data = res.data;
        const options = Array.isArray(data)
          ? data
          : data?.options || data?.items || [];

        // Chuẩn hóa một nguồn option để AutoComplete luôn giữ mã code và hiển thị tên lý do.
        return options.map((option) => ({
          ...option,
          value: option.value ?? option.code,
          label: option.label ?? option.name,
        }));
      });
  }
}
